const c=(t,r=0,o=1)=>t>o?o:t<r?r:t,n=(t,r=0,o=Math.pow(10,r))=>Math.round(o*t)/o;export{c as clamp,n as round};
